import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { swaggerUIBundle, swaggerUIStandalonePreset } from '../../polyfills';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

@Component({
  templateUrl: './api-docs.component.html'
})
export class ApiDocsComponent implements OnInit, AfterViewInit {

  constructor(private el: ElementRef,
              private environment: EnvironmentConfiguration) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const ui = swaggerUIBundle({
      urls: [{
        url: this.environment.baseUrl + '/swagger.json', name: 'GroupPay API'
      }],
      domNode: this.el.nativeElement.querySelector('.swagger-container'),
      deepLinking: true,
      presets: [
        swaggerUIBundle.presets.apis,
        swaggerUIStandalonePreset
      ],
      plugins: [
        swaggerUIBundle.plugins.DownloadUrl
      ],
      layout: 'StandaloneLayout'
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/api-docs/api-docs.component.ts